import { Link } from 'react-router-dom';
import { mainCategories } from '@/mocks/categories';

export default function QuickCategories() {
  return (
    <section className="mx-auto w-full px-4 md:px-6">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
        {mainCategories.map((cat, index) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex items-center gap-4 overflow-hidden rounded-lg border border-background-200/70 bg-background-50 p-4 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200 md:gap-5 md:p-5"
            style={{ animationDelay: `${index * 80}ms` }}
          >
            <div className="h-20 w-20 shrink-0 overflow-hidden rounded-lg bg-background-200 md:h-24 md:w-24">
              <img
                src={cat.cover}
                alt={cat.name}
                title={`${cat.name}分类 - 麻豆精品入口蜜桃`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="min-w-0">
              <div className="flex items-center gap-2">
                <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                  <i className={`${cat.icon} text-base`} />
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-900">{cat.name}</h3>
              </div>
              <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-500">{cat.desc}</p>
            </div>
            <i className="ri-arrow-right-line ml-auto hidden text-foreground-300 transition-colors group-hover:text-primary-500 sm:block" />
          </Link>
        ))}
      </div>
    </section>
  );
}